<header>
  <div class="header-upper">
    <div class="header-upper-inner">
      <a class="logo" *ngIf="headerData && headerData['logo']" routerLink="/">
        <img src="{{ headerData['logo']?.data?.attributes?.url }}" />
      </a>
      <div class="login-container">
        <p>Protecting your every step.</p>
        <button routerLink="/login">Login</button>
      </div>
    </div>
  </div>
</header>
